import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../components/LanguageContext';
import './Header.css';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { language, toggleLanguage } = useLanguage();

  const content = {
    en: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      whatsapp: 'WhatsApp',
    },
    ar: {
      home: 'الرئيسية',
      about: 'من نحن',
      services: 'خدماتنا',
      whatsapp: 'واتساب',
    }
  };

  const t = content[language];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    setIsOpen(false);
    const el = document.querySelector(id);
    if (el) {
      const offset = 80;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const links = [
    { id: '#intro', label: t.home },
    { id: '#AboutUS', label: t.about },
    { id: '#services', label: t.services },
  ];

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        {/* Logo */}
        <a href="#intro" onClick={(e) => { e.preventDefault(); scrollTo('#intro'); }} className="logo">
          <img src={require("../Images/Icon.jpeg")} alt="Sparkles" />
        </a>

        {/* Desktop Nav */}
        <nav className="nav-desktop">
          {links.map((link) => (
            <a
              key={link.id}
              href={link.id}
              onClick={(e) => { e.preventDefault(); scrollTo(link.id); }}
              className="nav-link"
            >
              {link.label}
            </a>
          ))}
          
          <a
            href="https://wa.me/966560308877"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-cta"
          >
            <i className="fab fa-whatsapp" />
            {t.whatsapp}
          </a>

          <button onClick={toggleLanguage} className="lang-btn">
            {language === 'ar' ? 'EN' : 'عربي'}
          </button>
        </nav>

        {/* Mobile Toggle */}
        <button 
          className={`menu-toggle ${isOpen ? 'open' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Menu"
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence>
        {isOpen && (
          <motion.nav
            className="nav-mobile"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.2 }}
          >
            {links.map((link) => (
              <a
                key={link.id}
                href={link.id}
                onClick={(e) => { e.preventDefault(); scrollTo(link.id); }}
              >
                {link.label}
              </a>
            ))}
            
            <a
              href="https://wa.me/966560308877"
              target="_blank"
              rel="noopener noreferrer"
              className="mobile-cta"
            >
              <i className="fab fa-whatsapp" />
              {t.whatsapp}
            </a>

            <button onClick={() => { toggleLanguage(); setIsOpen(false); }} className="mobile-lang">
              {language === 'ar' ? 'English' : 'العربية'}
            </button>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
